module.exports = __webpack_public_path__ + "static/media/bannerblackfriday.c7d46c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/bannerblackfriday.png
// module id = 322
// module chunks = 0